import React from 'react'
import { AgilitasFundersDashboard } from './components/AgilitasFundersDashboard'

const AgilitasFundersApp: React.FC = () => {
  return <AgilitasFundersDashboard />
}

export default AgilitasFundersApp
